module.exports = __webpack_public_path__ + "img/android.e5dfcdc6.svg";